import {
  PLAY_SUCCESS,
  STOP_VIDEO
} from '../actions/video-player'

export default (state={playing:false}, action={})=> {
  switch (action.type) {
    case PLAY_SUCCESS:
      return {...state, ...(action||{}).data, ...{playing:true}}

    case STOP_VIDEO:
      return {...state, ...{playing:false}}
    default:
      return state
  }
}
